import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	function initializeSimpleSlider(selector) {
		const sliderElements = document.querySelectorAll(selector);
		// If Sliderelemnt can not be find, exit the function
		if (!sliderElements) return;

		if (sliderElements.length > 0) {
			sliderElements.forEach(function (sliderElement) {
				let splideInstance; // Declare splideInstance here, in the forEach loop's scope

				if (sliderElement.splide) {
					// Check if a Splide instance already exists on sliderElement and destroys it before initializing a new one.
					sliderElement.splide.destroy();
				}

				// Prevent duplicate initialization
				if (sliderElement.classList.contains("is-initialized")) return;
				sliderElement.classList.add("is-initialized");

				//
				// Initialize Splide slider and store the instance
				//
				splideInstance = new Splide(sliderElement, {
					type: "loop",
					perPage: 1,
					perMove: 1,
					rewind: true,
					arrows: false,
					gap: "0",
					pagination: false,
					mediaQuery: "min",
					autoplay: true,
					interval: 3000, // 3 seconds
					breakpoints: {
						768: {
							// perPage: 1,
							// gap: "2.4rem",
						},
						1200: {
							//perPage: 3,
						},
						1500: {
							// perPage: 4,
							// drag: false,
						},
					},
				}).mount();

				//
				// If custom arrows need to be added
				//
				if (sliderElement.querySelector(".custom-arrows")) {
					const prevButton =
						sliderElement.querySelector(".custom-prev");
					const nextButton =
						sliderElement.querySelector(".custom-next");

					// Create custom arrow elements if they don't exist
					if (!sliderElement.querySelector(".custom-prev")) {
						const prevButton = document.createElement("button");
						prevButton.classList.add("custom-prev");
						prevButton.textContent = "Prev"; // Or use an icon
						sliderElement.appendChild(prevButton);
					}
					if (!sliderElement.querySelector(".custom-next")) {
						const nextButton = document.createElement("button");
						nextButton.classList.add("custom-next");
						nextButton.textContent = "Next"; // Or use an icon
						sliderElement.appendChild(nextButton);
					}

					// Function to update arrow visibility
					const updateArrowVisibility = () => {
						const currentPerPage = splideInstance.options.perPage;
						const totalSlides = splideInstance.length;

						if (totalSlides <= currentPerPage) {
							if (prevButton) prevButton.style.display = "none";
							if (nextButton) nextButton.style.display = "none";
						} else {
							if (prevButton) prevButton.style.display = ""; // Reset to default CSS display
							if (nextButton) nextButton.style.display = "";
						}
					};

					// Initial check and update on resize/update
					updateArrowVisibility();
					splideInstance.on("resized updated", updateArrowVisibility);

					// add event listener if buttons exists
					if (prevButton) {
						prevButton.addEventListener("click", () => {
							splideInstance.go("-1");
						});
					}
					if (nextButton) {
						nextButton.addEventListener("click", () => {
							splideInstance.go("+1");
						});
					}
				}
			});
		}
	}

	//Initialize slider for team which has an unique ID
	//Any other blocks which use similar style of slide can be initilzed from here
	initializeSimpleSlider("#team-slider");
	initializeSimpleSlider(".slider-block__container");
	initializeSimpleSlider(".itinerary-block__container");

	//gallery sliders
	const gallerySlider = document.querySelector(".gallery-splide-slider");

	if (gallerySlider) {
		const isAutoplaying = gallerySlider.classList.contains("autoplaying");

		const splide = new Splide(gallerySlider, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			rewind: true,
			arrows: false,
			pagination: true,
			focus: "center",
			gap: "3.2rem",
			fixedWidth: "50%",
			autoplay: isAutoplaying,
			mediaQuery: "min",
			breakpoints: {
				600: {
					perPage: 3,
					fixedWidth: null,
					gap: "2.4rem",
					focus: 0,
				},
				768: {
					perPage: 4,
				},
				1000: {
					perPage: 5,
				},
				1200: {
					perPage: 6,
				},
			},
		});

		splide.mount();
	}
});
